import Tabs from '@mui/material/Tabs';
import Tab, {TabProps as TabPropsMui} from '@mui/material/Tab';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PlaceIcon from '@mui/icons-material/Place';
import SettingsIcon from '@mui/icons-material/Settings';
import {styled} from "@mui/material/styles";
import {Link} from "react-router-dom";
import {useRouteMatch} from "hooks/useRouteMatch.ts";
import { useContext } from "react"
import { FeatureToggle } from "App.tsx"
import { BatterySessionIcon } from "layouts/sessions/utils/icons.tsx"

type TabProps = TabPropsMui & {
    to: string
}

export function Menu() {
    const featureContext = useContext(FeatureToggle)
    const menuTabs = [
        {
            icon: <ShowChartIcon/>,
            label: "Tableau de bord",
            to: "/board",
            toggle: featureContext
        },
        {
            icon: <CreditCardIcon/>,
            label: "Cartes de recharge",
            to: "/cards",
            toggle: true
        },
        {
            icon: <ReceiptIcon/>,
            label: "Finances",
            to: "/invoices",
            toggle: featureContext
        },
        {
            icon: <BatterySessionIcon sx={{
                fontSize: '2rem',
                mr: '0.5rem',
                '& path': {
                    fill: 'currentColor'
                }
            }} />,
            label: "Recharges",
            to: "/sessions",
            toggle: true
        },
        {
            icon: <PlaceIcon/>,
            label: "Stations",
            to: "/locations",
            toggle: featureContext
        },
        {
            icon: <SettingsIcon/>,
            label: "Paramètres",
            to: "/settings",
            toggle: true
        },
    ]
    const MenuTab = styled((props: TabProps) =>
        <Tab
            {...props}
            disableRipple
            iconPosition="start"
            sx={{
                typography: "title",
            }}
        />
    )(
        ({theme}) => ({
            textTransform: 'none',
            transition: "color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
            color: theme.palette.darkgrey.main,
            minHeight: "48px",
            maxHeight: "48px",
            '&:hover, &:focus': {
                color: theme.palette.secondary.main,
                boxShadow: `0 -2px ${theme.palette.secondary.main} inset`,
                opacity: 1,
            },
        }),
    );
    const routesMenu = menuTabs.map((tab) => tab.to)
    const routeMatch = useRouteMatch(routesMenu);

    return (
        <Tabs
            value={routeMatch ?? false}
            variant="scrollable"
            scrollButtons="auto"
            textColor={"secondary"}
            indicatorColor="secondary"
            aria-label="main menu tabs"
            sx={{
                '& .MuiTabs-flexContainer': {
                    maxWidth: `${menuTabs.length * 184}px`,
                    justifyContent: "space-between",
                },
                '& .MuiTabScrollButton-root': {
                    overflow: 'hidden',
                    transition: "color 0.2s ease-in-out",
                    '&:hover': {
                        color: "secondary.main",
                    },
                    '&.Mui-disabled': {
                        width: 0,
                    },
                },

            }}
        >
            {menuTabs.map((tab) =>
                tab.toggle ? (
                    <MenuTab
                        key={tab.to}
                        value={tab.to}
                        icon={tab.icon}
                        label={tab.label}
                        to={tab.to}
                        component={Link}
                        data-cy={`header-nav__${tab.to.replace('/', '')}`}
                    />
                ) : null
            )}
        </Tabs>
    );
}